// src/services/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA6xZJEf5bmnnmPVXTp46O64tu7mxgpifc",
  authDomain: "druida-39294.firebaseapp.com",
  projectId: "druida-39294",
  storageBucket: "druida-39294.firebasestorage.app",
  messagingSenderId: "288175208699",
  appId: "1:288175208699:web:899e4648d87fe2b0b2985e",
  measurementId: "G-YX5GB56TPG"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage, app };
